import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PartnerService } from 'src/app/partner/partner.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../core/authentication/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  title = 'Login';
  isTecalis = false;
  checkingUpdate: boolean = false;
  qrcode: any;
  isRedirecting: boolean = false;
  showLogoutMessage: boolean = true;
  errorMessage: string | null = null;

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private service: PartnerService
  ) { }

  login() {
    this.isRedirecting = true;
    this.spinner.show();
    this.authService.login();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const hasVerificationCode =
        params['verificationcode'] != undefined &&
        params['verificationcode'] == '6e9dd38c-1a52-4c0f-9089-59ef4c16bb70';
      const isLogout = params['logout'] === 'true';
      const hasError = !!params['error'];

      // Solo limpiar OIDC si logout=true
      if (isLogout) {
        const oidcPrefixes = ['oidc_', 'oidc.', 'oidc:user', 'oidc:user:'];
        [sessionStorage, localStorage].forEach(storage => {
          for (let i = storage.length - 1; i >= 0; i--) {
            const key = storage.key(i);
            if (key && oidcPrefixes.some(prefix => key.startsWith(prefix))) {
              storage.removeItem(key);
            }
          }
        });
        this.authService.clearLoginProgress();
        sessionStorage.removeItem('oidc_login_in_progress');
        sessionStorage.removeItem('oidc_login_in_progress_at');
      }


      // Si hay error, mostrar mensaje y no redirigir automáticamente
      if (hasError) {
        this.showLogoutMessage = false;
        this.isRedirecting = false;
        this.spinner.hide();
        const err = params['error'];
        if (err === 'access_denied') {
          this.errorMessage = 'Has cancelado el proceso de autenticación.';
        } else {
          this.errorMessage = 'Error de autenticación: ' + err;
        }
        return;
      }

      if(params['passwordchanged'] == 'true'){
        this.login();
        return;
      }

      if (this.authService.isAuthenticated()) {
        this.qrcode = environment.spaUrl + "/login?idpartneruser=" + this.authService.sub + "&idpartner=" + this.authService.idpartner + "&verificationcode=6e9dd38c-1a52-4c0f-9089-59ef4c16bb70";
        if(this.authService.status == 0 || this.authService.status == 1 || this.authService.status == 2){
          if(this.authService.idpartner != ""){
            this.service.CheckPartnerStatus(this.authService.authorizationHeaderValue, this.authService.idpartner)
            .subscribe(
              (result: any) => {
                this.authService.status = result;
                switch (result) {
                  case 1:
                    this.router.navigate(['/partner/register']);
                    break;
                  case 2:
                    this.router.navigate(['/partner/sign']);
                    break;
                  case 3:
                  case 4:
                  case 6:
                  case 7:
                    break;
                  default:
                    break;
                }
              });
          }
        }
      } else {
        if (hasVerificationCode) {
          this.router.navigate(['/lead/newnoauth'], { queryParams: { IdPartnerUser: params['idpartneruser'], IdPartner: params['idpartner'] } })
        } else {
          // Solo login automático si venía de ruta protegida
          if (this.authService.wasRedirectedFromProtectedRoute()) {
            this.authService.setRedirectedFromProtectedRoute(false);
            this.login();
          } else {
            this.showLogoutMessage = true;
            this.isRedirecting = false;
            this.spinner.hide();
          }
        }
      }
    });
  }

  newLead() {
    this.router.navigate(['/lead/new']);
  }

  listLead() {
    this.router.navigate(['/lead']);
  }

  getQRSize(): number {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width <= 480) return 150;
      if (width <= 768) return 180;
      if (width <= 992) return 200;
      return 220;
    }
    return 200;
  }
}


